export const recaptchaSiteKey = '6Lesx1UqAAAAAKInKgHobOlgUGGskMCGQ3HbxCLF';
export const recaptchaSecretKey = '6Lesx1UqAAAAAE7lRts5anCxp5OlJq0U5TecTIkI';